import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import * as app from '../../app.selector';
import * as applications from '../../modules/applications/application.selector';
import * as card from '../../modules/card/card.selector';
import * as history from '../../modules/history-requests/history-requests.selector';
import * as consent from '../../modules/consent/consent.selector';
import { AppState } from '../../app.state';
import { Observable } from 'rxjs/Observable';
import * as errorAction from '../../core/actions/clear-error.action';
import { ContainerComponent } from '../../modules/shared/components/container-component/unsubscribe.component';

import 'rxjs/add/observable/combineLatest';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/concatMap';
import 'rxjs/add/operator/takeUntil';

@Component({
    selector: 'ssf-error-page',
    template: `
        <div class="ssf-error__heading">
            {{i18n + 'TITLE' | translate}}
        </div>
       <div *ngFor="let key of keys()">
            {{errors[key].statusText}}
        </div>
        
        <p>{{i18n + 'INSTRUCTIONS' | translate}}</p>
    `,
    styles: [
            `
            :host {
                text-align: center;
            }

            .ssf-error__heading {
                font-size: 2rem;
            }
        `,
    ],
})
export class ErrorComponent extends ContainerComponent {
    public i18n = 'APP.ERROR.';

    public errors: any;

    constructor(private store: Store<AppState>) {
        super();

        Observable.combineLatest(
            this.store.select(app.selectLoadingError),
            this.store.select(applications.selectLoadingError),
            this.store.select(card.selectLoadingError),
            this.store.select(history.selectLoadingError),
            this.store.select(consent.selectLoadingError))
            .takeUntil(this.ngUnsubscribe)
            .concatMap(x => x)
            .filter(x => !!x  &&  Object.keys(x).length !== 0)
            .subscribe(err => this.errors = err);

        this.store.dispatch(new errorAction.ClearErrorAction());
    }

    public keys() {
        if (!this.errors) {
            return [];
        }

        return Object.keys(this.errors);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/components/error/error.component.ts